import { baseUrl } from './util';
import request from '@/utils/request';
import { setLocaleQuery } from '@/utils';
import getIgnoreTokenHeader from 'lowcode/utils/service/getIgnoreTokenHeader';

// 根据变体ID获取产品列表-新
export const shopifyProductVariantSelectById = (locale: string | undefined, variantIds: string[]) => {
    return request.post(`${baseUrl(locale)}/ProductCaculation/productInfoList${setLocaleQuery(locale)}`, {
        data: {
            variantIds,
        },
        headers: {
            ...getIgnoreTokenHeader(),
        },
    });
};
